import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Card, CircularProgress, Modal, TextField, Typography, Avatar, Badge } from '@mui/material';
import { Box, Stack } from '@mui/system';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from "yup";
import SnackBarUI from '../../comman/SnackBarUI';
import { addManegerDetailsAction } from '../../redux/toolkit/publisher/addManegerDetails';
import { approvedPaymentAction } from '../../redux/toolkit/payments/approvedPayment';
import { getPublisherAction } from '../../redux/toolkit/publisher/getPublisher';



// schema
const catSchema = yup.object({
    amount: yup
    .number().required('Amount is required.')
    .typeError('Amount must be a number'),
    

}).required();

const RaisePaymentRequest = ({state, setState, publisher_id}) => {
    // state
    const { register, setValue, handleSubmit, formState: { errors }, reset } = useForm({ resolver: yupResolver(catSchema) });
    const dispatch = useDispatch()

    const paymentApproval = useSelector(state => state.approvedPayment)
    const { status, message, loading } = paymentApproval
    const [snack, setSnack] = useState(false)
   

   
    const handlePaymentRaiseDetails = async (data) => {
        setSnack(true)
        const paymentApprovedDetails = await dispatch(approvedPaymentAction({ publisher_id:publisher_id, ...data }))
        if (paymentApprovedDetails?.payload?.status == 200) {
            dispatch(getPublisherAction())
            setTimeout(() => {

                setState(false)
            }, 1000);
            reset()

        }

        // setSnack(true)
    }


    const handleClose = function () {
        setState(false)
    }

    return (
        <>
            <Modal sx={{ overflow: 'scroll' }} open={state} onClose={handleClose}>
                <Box className='modal_box'>
                    <Card sx={{ width: 400, p: 5 }}>
                        <Typography variant='h5' sx={{ mb: 5 }} align='center'>Raise Payment Request</Typography>
                        <form onSubmit={handleSubmit(handlePaymentRaiseDetails)}>
                            <Stack spacing={3}>
                                
                                <TextField type='text' label="Amount" variant="outlined" placeholder='Amount' {...register('amount')} error={errors?.amount?.message} helperText={errors?.amount?.message} />
                                
                                <Stack direction='row' spacing={2}>
                                    {/* <Button variant='contained' type='submit' disabled={loading}>{loading ? <CircularProgress /> : {{publisherDetails?.m_name} ? 'Update Manager' :'Add Manager'}}</Button> */}
                                    <Button variant="contained" type="submit" disabled={loading}>
                                        Raise Request
                                    </Button>

                                    <Button variant='contained' color='error' onClick={handleClose}>Close</Button>
                                </Stack>
                            </Stack>
                        </form>
                    </Card>
                </Box>
            </Modal>
            <SnackBarUI state={snack} setState={setSnack} status={status} message={message} />
        </>
    )
}

export default RaisePaymentRequest
